<template>
  <div class="content">
    <van-sticky>
      <div class="video_wrapper" ref="video_wrapper">
        <video-player v-if="videoShow" class="video" ref="videoPlayer" :playsinline="true" :options="playerOptions"
          :src="src">
        </video-player>
        <div class="left_arrow" @click="back">
          <van-icon name="arrow-left" color="#ffffff" size="20" />
        </div>
      </div>
    </van-sticky>
    <div class="video_message">
      <p class="video_message_title">{{videoMsg.title}}</p>
      <p class="video_message_txt">{{videoMsg.content}}</p>
    </div>
    <van-sticky :offset-top="offsetHeight">
      <div class="video_message_bottom_fixed">
        <div class="video_message_bottom_left">
          <img v-if="videoMsg.portrait == ''" class="face" src="../../assets/house/videoHead.png" alt="">
          <img class="face" v-else :src="videoMsg.portrait" alt="">
          <div class="name">
            <span class="publisher">{{videoMsg.publisher}}</span>
            <span class="screen_num">{{videoMsg.screen_num}}次播放</span>
          </div>
        </div>
        <div class="video_message_bottom_right">
          <div class="video_message_bottom_right_like" @click="handleLike(videoMsg.id)">
            <img class="handLikeImg" v-if="is_likes==1" src="../../assets/house/handLike.png" alt="">
            <img class="handLikeImg" v-if="is_likes==-1" src="../../assets/house/noHandLike.png" alt="">
            <span
              :class="[is_likes == 1?'video_message_bottom_right_likes_num':'video_message_bottom_right_disLikes_num']">{{likes_num == 0?'点赞':likes_num}}</span>
          </div>
          <div class="video_share" id="copycode" @click="copyLink()" :data-clipboard-text='copyContent'>
            <img class="video_share_icon" src="../../assets/house/video_share_icon.png" alt="">
            <span class="video_message_bottom_right_disLikes_num">分享</span>
          </div>
        </div>
      </div>
    </van-sticky>
    <div class="list">
      <p class="recommend_title">精彩推荐</p>
      <van-row gutter="16">
        <van-col class="video_item" span="12" v-for="(item,index) in videoList" :key="index" @click="goPlay(item)">
          <div class="video_img_box">
            <img class="videoImg" :src="item.video_cover[0]">

            <div class="video_shadow">
              <div class="video_shadow_left">
                <img class="video_shadow_left_img" src="../../assets/house/video_shadow_play.png" alt="">
                <span class="video_shadow_left_txt">{{item.screen_num}}</span>
              </div>
            </div>
          </div>
          <div class="video_item_bottom">
            <p class="video_item_title">{{item.title}}</p>
            <div class="video_item_bottom_like">
              <span class="video_item_bottom_like_left">{{item.publisher}}</span>
              <div class="video_item_bottom_like_right">
                <img v-if="item.video_fabulous != null" class="video_item_bottom_like_img"
                  src="../../assets/house/video_like.png" alt="">
                <img v-else class="video_item_bottom_like_img" src="../../assets/house/videoDislike.png" alt="">
                <span
                  :class="[item.video_fabulous != null?'video_item_bottom_like_right_dislike_txt':'video_item_bottom_like_right_like_txt']">{{item.likes_num}}</span>
              </div>
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
  import Bus from '@/providers/eventBus.js';
  import Clipboard from 'clipboard';
  export default {
    data() {
      return {
        id: '',
        src: '',
        offsetHeight: 0,
        videoShow: false,
        videoMsg: {},
        videoList: [],
        likeClick: true,
        is_likes: Number,
        likes_num: '',
        headSrc: '',
        copyContent: '',
        playerOptions: {
          playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
          autoplay: true, //如果true,则自动播放
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 循环播放
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。

          sources: [{ // 播放资源和资源格式
            type: "video/mp4",
            src: '' //你的视频地址（先为空，之后动态赋值）
          }],
          poster: "", //视频封面图
          width: document.documentElement.clientWidth, // 默认视频全屏时的最大宽度
          notSupportedMessage: '加载中...', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        }
      }
    },
    created() {
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token);
      }
      this.id = this.$route.query.id
      this.getVideoDetail(this.id)
      this.getVideoList('screen_num', 10, 1)
      this.copyContent = `${process.env.VUE_APP_BASE_URL}/house/playerShare?id=${this.id}`
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      getVideoDetail(id) {
        this.$api.get('estate/member/video/zone/detail', {
          id
        }).then(res => {
          this.videoMsg = res
          this.is_likes = res.is_likes
          if (res.likes_num == 0) {
            this.likes_num = '点赞'
          } else {
            this.likes_num = res.likes_num
          }
          if (res.portrait == '') {
            this.headSrc = '../../assets/house/videoHead.png'
          } else {
            this.headSrc = res.portrait
          }
          this.playerOptions['sources'][0]['src'] = res.video[0];
          this.videoShow = true
          setTimeout(() => {
            this.offsetHeight = this.$refs.video_wrapper.offsetHeight;
          })
        })
      },
      getVideoList(orderBy, pageSize, page) {
        this.$api.post('estate/member/video/zone/list', {
          orderBy,
          pageSize,
          page
        }).then(res => {
          this.videoList = res.list
        })
      },
      goPlay(item) {
        this.getVideoDetail(item.id)
      },
      copyLink() {
        var clipboard = new Clipboard("#copycode");
        clipboard.on("success", (e) => {
          this.$toast("复制成功");
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          // 不支持复制
          this.$toast("复制失败");
          // 释放内存
          clipboard.destroy();
        });
      },
      handleLike(id) {
        this.$api.post("estate/member/video/zone/likes", {
          id
        }).then(res => {
          if (this.likeClick) {
            this.likeClick = false
            this.videoMsg.screen_num++
          }
          if (this.is_likes == -1) {
            this.$toast("点赞成功");
            this.likes_num++
          } else {
            this.$toast("取消成功");
            this.likes_num--
          }
          this.is_likes = -this.is_likes
          Bus.$emit('__updateVideoItem', {
            id,
            like: this.is_likes
          });
          // this.$api.get('estate/member/video/zone/detail', {
          //   id
          // }).then(res => {
          //   if (res.is_likes == 1) {
          //     this.$toast("点赞成功");
          //   } else {
          //     this.$toast("取消成功");
          //   }
          //   this.is_likes = res.is_likes
          //   this.likes_num = res.likes_num
          //   Bus.$emit('__updateVideoItem', {
          //     id,
          //     like: res.is_likes == 1
          //   });
          // })
          this.getVideoList('screen_num', 10, 1)
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .content {
    box-sizing: border-box;
    height: 100%;
    font-size: 16px;
    color: #333;
    overflow: auto;
  }

  .video_wrapper {
    /* ios < 11.2 */
    padding-top: constant(safe-area-inset-top);
    /* ios >= 11.2 */
    padding-top: env(safe-area-inset-top);
    padding-top: var(--status-height);
    position: relative;
    background-color: #ffffff;
  }

  .left_arrow {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 60px;
    left: 15px;
  }

  .video {
    width: 100%;
    // height: 211px;
    // position: absolute;
    // bottom: 0;
  }

  /deep/.video-js .vjs-big-play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .list {
    height: 100%;
    // background-color: aqua;
    padding: 0 16px 30px;
  }

  .video_message {
    padding: 0 12px;
  }

  .video_message_title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    line-height: 24px;
    padding: 20px 0 8px;
  }

  .video_message_txt {
    font-size: 12px;
    color: #999999;
    line-height: 24px;
  }

  .video_message_bottom_fixed {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 20px 12px 24px;
    background-color: #ffffff;
  }

  .video_message_bottom_left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .video_message_bottom_right {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .video_share {
    margin-left: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .face {
    width: 36px;
    height: 36px;
    margin-right: 8px;
  }

  .name {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    height: 36px;
  }

  .publisher {
    font-size: 14px;
    color: #333333;
  }

  .screen_num {
    font-size: 12px;
    color: #999999;
  }

  .video_message_bottom_right_like {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .video_share_icon {
    width: 28px;
    height: 28px;
  }

  .handLikeImg {
    width: 28px;
    height: 28px;
    /* margin-left: 24px; */
  }

  .video_message_bottom_right_likes_num {
    font-size: 12px;
    color: #FF704F;
    line-height: 10px;
    /* margin-right: 24px; */
  }

  .video_message_bottom_right_disLikes_num {
    font-size: 12px;
    color: #BEC7CF;
    line-height: 10px;
    /* margin-right: 24px; */
  }

  .recommend_title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    padding-bottom: 16px;
  }

  .videoList {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 10px;
  }

  .video_item {
    height: 214px;
    margin-top: 12px;
    border-radius: 8px;
    box-shadow: 0px 4px 16px 0px rgba(206, 208, 213, 0.44);
  }

  .video_Noitem {
    width: 166px;
    height: 214px;
    margin-top: 12px;
    border-radius: 8px;
  }

  .video_img_box {
    // width: 166px;
    width: 100%;
    height: 132px;
    position: relative;
  }

  .videoImg {
    // width: 166px;
    width: 100%;
    height: 132px;
    border-radius: 8px 8px 0px 0px;
  }

  .upTopImg {
    position: absolute;
    top: 0;
    left: 0;
    width: 36px;
    height: 20px;
  }

  .video_shadow {
    // width: 166px;
    width: 100%;
    height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    border-radius: 0 0 8px 8px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
  }

  .video_shadow_left {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 12px;
  }

  .video_shadow_left_img {
    width: 12px;
    height: 12px;
    margin-right: 3px;
  }

  .video_shadow_left_txt {
    font-size: 12px;
    color: #F5F5F5;
  }

  .video_item_bottom {
    // width: 166px;
    width: 100%;
  }

  .video_item_title {
    font-size: 12px;
    font-weight: bold;
    line-height: 15px;
    color: #333333;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    padding: 12px 8px 0;
    height: 30px;
    width: 150px;
  }

  .video_item_bottom_like {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 8px;
    // padding-bottom: 12px;
  }

  .video_item_bottom_like_left {
    font-size: 12px;
    color: #999999;
  }

  .video_item_bottom_like_right {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .video_item_bottom_like_img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .video_item_bottom_like_right_like_txt {
    font-size: 12px;
    color: #999999;

    line-height: 14px;
  }

  .video_item_bottom_like_right_dislike_txt {
    font-size: 12px;
    color: #FF704F;

    line-height: 14px;
  }
</style>